import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import React from "react";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
import { takeFirst } from "~/features/app/utils";
import { Wrap } from "~/features/ui/wrap";
import { useMediaQuery } from "~/features/ui/use-media-query";
import { up } from "~/features/app/screens";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type PointCloudBlockViewProps = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  bottomMedia?: React.ReactNode;
  hasTopDivider?: boolean | null;
  maxZoom?: string | null;
  media?: (overlay: React.ReactNode, ratio: "2/1" | "5/6") => React.ReactNode;
  minZoom?: string | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
  title?: string | null;
  topMedia?: React.ReactNode;
};
export function PointCloudBlockView({
  anchor,
  bottomMedia,
  hasTopDivider = true,
  maxZoom,
  media,
  minZoom,
  mode = "light",
  sectionProps,
  theme = "white",
  title,
  topMedia
}: PointCloudBlockViewProps) {
  const themeStyle = getThemeStyle({
    mode: mode as Mode,
    theme: theme as Theme
  });
  const isLg = useMediaQuery(up("lg"));
  const ratio = isLg ? "2/1" : "5/6";
  return <_StyledSection {...sectionProps} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[hasTopDivider && {
    "borderTopWidth": "1px"
  }, themeStyle.border, themeStyle.background, themeStyle.text]}>
      <Wrap mode={mode as Mode}>
        <_StyledDiv>
          <_StyledDiv2 $_css2={[{
          "position": "relative",
          "zIndex": "10"
        }, themeStyle.background]}>
            {media?.(<>
                <_StyledDiv3>
                  <_StyledP>{title}</_StyledP>
                  {topMedia}
                </_StyledDiv3>
                <_StyledDiv4>
                  {bottomMedia}
                  {minZoom && maxZoom && <div>
                      <_StyledDiv5>
                        <span>{minZoom}</span>
                        <span>{maxZoom}</span>
                      </_StyledDiv5>
                      <svg width="115" height="12" viewBox="0 0 115 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1" y1="2.18557e-08" x2="0.999999" y2="12" stroke="currentColor" />
                        <line x1="0.5" y1="5.5" x2="113.5" y2="5.5" stroke="currentColor" />
                        <line x1="114" y1="2.18557e-08" x2="114" y2="12" stroke="currentColor" />
                      </svg>
                    </div>}
                </_StyledDiv4>
              </>, ratio)}
          </_StyledDiv2>
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-sf2e6b-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-sf2e6b-1"
})({
  "@media (min-width: 1024px)": {
    "padding": "4rem"
  }
});
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-sf2e6b-2"
})`${p => p.$_css2}`;
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-sf2e6b-3"
})({
  "position": "absolute",
  "inset": "1.6rem",
  "bottom": "auto",
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.6rem",
  "@media (min-width: 1024px)": {
    "inset": "4rem",
    "bottom": "auto",
    "flexDirection": "row",
    "justifyContent": "space-between"
  }
});
var _StyledP = _styled5("p").withConfig({
  componentId: "sc-sf-sf2e6b-4"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-sf2e6b-5"
})({
  "position": "absolute",
  "inset": "1.6rem",
  "top": "auto",
  "display": "flex",
  "alignItems": "flex-end",
  "justifyContent": "space-between",
  "gap": "3.2rem",
  "@media (min-width: 1024px)": {
    "inset": "4rem",
    "top": "auto"
  }
});
var _StyledDiv5 = /*#__PURE__*/_styled7("div").withConfig({
  displayName: "point-cloud___StyledDiv5",
  componentId: "sc-d4nu74-0"
})({
  "marginBottom": "0.8rem",
  "display": "flex",
  "justifyContent": "space-between",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});